<template>
  <button
    type="button"
    class="overlap-ol-chip-btn"
    :title="title"
    :aria-label="ariaLabel"
    @click.stop="$emit('click', $event)"
  >
    <span class="overlap-ol-chip">OL</span>
  </button>
</template>

<script>
export default {
  name: 'overlap_correction_icon_btn',

  props: {
    title: {
      type: String,
      default: 'Overlap correction applied — click for details',
    },
    ariaLabel: {
      type: String,
      default: 'View overlap correction details',
    },
  },
}
</script>

<style scoped>
.overlap-ol-chip-btn {
  flex-shrink: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 1;
}
.overlap-ol-chip-btn:hover:not(:disabled) .overlap-ol-chip {
  background: hsla(211, 100%, 88%, 0.98);
  border-color: #0a58ca;
  color: #084298;
}
.overlap-ol-chip-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.overlap-ol-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.35rem;
  height: 1rem;
  padding: 0 0.2rem;
  border: 1px solid #0d6efd;
  border-radius: 999px;
  background: hsla(211, 100%, 93%, 0.95);
  color: #0a58ca;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.03em;
  line-height: 1;
}
</style>
